export default ({
    "base_url": "",
    "routes": {

      "api_dtable_list_dtable_rmboxs_list_status": {
        "tokens": [
          [
            "text",
            "/dataTable/rmboxs-list-status"
          ]
        ],
        "defaults": [],
        "requirements": [],
        "hosttokens": []
      },

      "api_configuration_post_edit_alive_rmbox": {
        "tokens": [
          [
            "variable",
            "/",
            "\\d+",
            "id"
          ],
          [
            "text",
            "/rmbox/edit-alive"
          ]
        ],
        "defaults": [],
        "requirements": {
          "id": "\\d+"
        },
        "hosttokens": []
      },
      "api_configuration_get_status_client_config": {
        "tokens": [
          [
            "text",
            "/rmbox/status-client-config"
          ]
        ],
        "defaults": [],
        "requirements": [],
        "hosttokens": []
      },
      "api_dtable_get_missing_videos_rmbox": {
        "tokens": [
          [
            "variable",
            "/",
            "\\d+",
            "id"
          ],
          [
            "text",
            "/dataTable/missing-videos-rmbox"
          ]
        ],
        "defaults": [],
        "requirements": {
          "id": "\\d+"
        },
        "hosttokens": []
      },
      "api_dtable_list_dtable_intervention_rmboxs_list": {
        "tokens": [
          [
            "text",
            "/dataTable/intervention-rmbox-list"
          ]
        ],
        "defaults": [],
        "requirements": [],
        "hosttokens": []
      },
        "api_dtable_list_dtable_unknown_ip_list": {
            "tokens": [
                [
                    "text",
                    "/dataTable/unknown-ip-list"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_dtable_get_player_incidents": {
            "tokens": [
                [
                    "text",
                    "/dataTable/player-incidents"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
      "post_login": {
        "tokens": [
          [
            "text",
            "/login"
          ]
        ],
        "defaults": [],
        "requirements": [],
        "hosttokens": []
      }

    },
    "prefix": "",
    "host": "localhost",
    "scheme": "http"
});



// WEBPACK FOOTER //
// ./src/core/router/fos_js_routes_export.js